
<template>
  <div v-if="Attributes" class="jumbotron_">

    <label style="color:darkblue;font-weight: bolder;">ATTRIBUTI CUSTOM</label>

    <!-- Riga principale per le select -->
    <div class="row">
      <div
        v-for="attrObj in Attributes"
        :key="attrObj.attribute.id"
        class="col-auto mb-1"
      >
        <label :for="'attr-' + attrObj.attribute.id">{{ attrObj.attribute.name }}</label>
        
        <select 
          @change="setData()"
          class="form-control  form-control-sm"
          :id="'attr-' + attrObj.attribute.id"
          v-model="attrObj.selectedValueId"
        >
        <option value='0'>SELEZIONA UN VALORE ...</option>
        <option
            v-for="val in attrObj.attribute.values"
            :key  =  "val.id"
            :value = "val.id"
          >
            {{ val.value }}
        </option>
        </select>
      

      </div>
    </div>

    <!-- Bottone di salvataggio -->
   

    <!-- Preview per debug -->
    <pre v-if="false" class="mt-3">{{ productAttributes }}</pre>
  </div>
</template>

<script>
import api from "@/api"
import { mapGetters }        from 'vuex';
export default {
  
  data() {
    return {
     
     
     
      Attributes: [],

     
   
    }
  },
    computed: 
    {     
     ...mapGetters(['company']) 
      
    },
  created()
  {
    this.getData()
  },  
  methods:{

    setData()
    {
       
       this.$emit('update',this.Attributes) 
       
       
    },
     async getData()
    {
        //this.bt_spinner = true
        
        this.Attributes = []
       // this.items      = []
        const sp        = 'spCompanyCustomAttributes'
        const payload = 
        {
            'companyId' : this.company.Id,sp   
        
        }
        

          try{ 

            const res = await api.post(payload)
            if (res.status !== 200) 
            {
              throw new Error(res.data ||  res)
            }
              if(res.data.recordsets[0].length > 0) 
               {
                  this.Attributes = res.data.recordsets[0][0]
                  //this.items      = res.data.recordsets[1]
                  
               }
              
              else
              {
                throw 'DATI INESISTENTI.'
              }

            
          }
          catch(err)  
          {
             
          }
  





        

        
      
    },  


  }
}
</script>
<style scoped>

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
</style>